<div class="daily-update-container">
    <span class="air-heading">Daily Update Command - Run Command</span>
    
    <div class="info-text">
        {{ onLoadMessage }}
    </div>

    <div *ngIf="updateComplete" class="success-section">
        <h3>Daily Update - Success</h3>
        <p class="success-text">{{ systemMessage }}</p>
    </div>

    <div class="button-container">
        <button pButton label="Run Update" class="btn-primary h-20" (click)="runUpdate()"></button>
    </div>
</div>
